// src/Utilities/Constants.js
import ConfigService from '../Services/ConfigService';

// export const API_URL_REGISTER_CARD = "https://valuecard.co.il/api/pos/club_member/RegisterClubMemberEx";
// export const API_URL_SEARCH_CARD = "https://valuecard.co.il/api/pos/club_member/SearchClubMember";

class Constants {
    static _config = null;

    static async initialize() {
        const configService = ConfigService.getInstance();
        Constants._config = await configService.loadConfig();
        return Constants._config;
    }

    // Base URLs
    static get API_URL() {
        return Constants._config?.apiUrl || "http://localhost:44346";
    }

    static get API_KEY() {
        return Constants._config?.apiKey || "";
    }

    static get IMAGE_URL() {
        return Constants._config?.imageUrl || "https://admin.10q-market.co.il";
    }

    static get SITE_NAME() {
        return Constants._config?.siteName || "SuperCommerce";
    }

    static get ENVIRONMENT() {
        return Constants._config?.environment || "development";
    }

    static get TRANZILA_ACCOUNT() {
        return Constants._config?.thirdParty?.tranzilaAccount;
    }

    // ========== ALL API ENDPOINTS (without /api/ prefix) ==========
    
    // Health & Site
    static get API_URL_HEALTH_CHECK() {
        return `${Constants.API_URL}/Api/Health`;
    }

    static get API_URL_GET_SITE() {
        return `${Constants.API_URL}/Site`;
    }

    static get API_URL_GET_MENU() {
        return `${Constants.API_URL}/Menu`;
    }

    static get API_URL_GET_GALLERY() {
        return `${Constants.API_URL}/Gallery`;
    }

    static get API_URL_GET_PAGE() {
        return `${Constants.API_URL}/Page`;
    }

    // Products & Categories
    
    static get API_URL_GET_UNITS() {
        return `${Constants.API_URL}/Unit`;
    }

    static get API_URL_GET_LABELS() {
        return `${Constants.API_URL}/Label`;
    }

    static get API_URL_GET_PRODUCTS() {
        return `${Constants.API_URL}/Product/Search`;
    }

    static get API_URL_GET_PRODUCT() {
        return `${Constants.API_URL}/Product`;
    }

    static get API_URL_QUERY() {
        return `${Constants.API_URL}/Product/Query`;
    }

    static get API_URL_GET_HOMEPAGE_PRODUCTS() {
        return `${Constants.API_URL}/Product/Home`;
    }

    static get API_URL_GET_CATEGORIES() {
        return `${Constants.API_URL}/Category/GetCategories`;
    }

    static get API_URL_GET_SUB_CATEGORIES() {
        return `${Constants.API_URL}/Category/GetSubCategories`;
    }

    static get API_URL_GET_CATEGORY_TITLE() {
        return `${Constants.API_URL}/Category/Title`;
    }

    static get API_URL_GET_PRODUCTS_BY_CATEGORY() {
        return `${Constants.API_URL}/Category`;
    }

    // Customer & Authentication
    static get API_URL_GET_USER_LOGIN() {
        return `${Constants.API_URL}/Customer/Login`;
    }

    static get API_URL_GET_GOOGLE_LOGIN() {
        return `${Constants.API_URL}/Customer/GoogleLogin`;
    }

    static get API_URL_GET_CUSTOMER() {
        return `${Constants.API_URL}/Customer/Get`;
    }

    static get API_URL_GET_CODE() {
        return `${Constants.API_URL}/Customer/Code`;
    }

    static get API_URL_RESET_PASSWORD() {
        return `${Constants.API_URL}/Customer/Reset`;
    }

    static get API_URL_REGISTER() {
        return `${Constants.API_URL}/Customer/Register`;
    }

    static get API_URL_GET_MY_PRODUCTS() {
        return `${Constants.API_URL}/Customer/MyProducts`;
    }

    static get API_URL_UPDATE_PROFILE() {
        return `${Constants.API_URL}/Customer/UpdateProfile`;
    }

    static get API_URL_GET_COUPON() {
        return `${Constants.API_URL}/Customer/Coupon`;
    }

    // Cart & Stock
    static get API_URL_GET_CART() {
        return `${Constants.API_URL}/Cart/Get`;
    }

    static get API_URL_GET_STOCK() {
        return `${Constants.API_URL}/Cart/Stock`;
    }

    static get API_URL_UPDATE_CART() {
        return `${Constants.API_URL}/Cart/Update`;
    }

    static get API_URL_LOAD_CART() {
        return `${Constants.API_URL}/Cart/LoadCart`;
    }

    static get API_URL_MOVE_CART() {
        return `${Constants.API_URL}/Cart/MoveCart`;
    }

    static get API_URL_ADJUST_ORDER() {
        return `${Constants.API_URL}/Cart/AdjustOrder`;
    }

    static get API_URL_GET_INGREDIENTS() {
        return `${Constants.API_URL}/Cart/Ingredients`;
    }

    // Orders & Invoices
    static get API_URL_GET_ORDERS() {
        return `${Constants.API_URL}/Order/Orders`;
    }

    static get API_URL_GET_ORDER() {
        return `${Constants.API_URL}/Order`;
    }

    static get API_URL_CREATE_ORDER() {
        return `${Constants.API_URL}/Order/NewOrder`;
    }

    static get API_URL_UPDATE_ORDER() {
        return `${Constants.API_URL}/Order/UpdateOrder`;
    }

    static get API_URL_GET_INVOICE() {
        return `${Constants.API_URL}/Invoice/Pdf`;
    }

    // Delivery & Location
    static get API_URL_GET_DELIVERY_WINDOWS() {
        return `${Constants.API_URL}/Delivery`;
    }

    static get API_URL_YISHUVIM() {
        return `${Constants.API_URL}/Yishuv/GetYishuvim`;
    }

    static get API_URL_YISHUVIM_GEO() {
        return `${Constants.API_URL}/Yishuv/GetYishuvimGeo`;
    }

    // Communication
    static get API_URL_SEND_EMAIL() {
        return `${Constants.API_URL}/SendEmail`;
    }

    // AI Chat
    static get API_URL_AI_CHAT() {
        return `${Constants.API_URL}/api/ai/chat`;
    }

    // External APIs (these stay the same)
    static get API_URL_REGISTER_CARD() {
        return "https://valuecard.co.il/api/pos/club_member/RegisterClubMemberEx";
    }

    static get API_URL_SEARCH_CARD() {
        return "https://valuecard.co.il/api/pos/club_member/SearchClubMember";
    }

    // Feature flags
    static isFeatureEnabled(feature) {
        return Constants._config?.features?.[feature] || false;
    }

    // Get any config value
    static getConfig(key, defaultValue = null) {
        const configService = ConfigService.getInstance();
        return configService.get(key, defaultValue);
    }


}

export default Constants;